import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import { BackTop } from "antd"
import { withRouter } from "react-router-dom"
import QuesPane from "./QuesPane"
export class ExamPagePane extends Component {
  static propTypes = {
    quesStore: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
  scrollToAnchor = (anchorName) => {
    if (anchorName) {
      let anchorElement = document.getElementById(anchorName);
      if (anchorElement) {
        anchorElement.scrollIntoView();
      }
    }
  }
  componentWillReceiveProps(nextProps) {

    if (nextProps.quesStore.curQuesIndex !== this.props.quesStore.curQuesIndex) {
      this.scrollToAnchor(`queStoreQuesPane${nextProps.quesStore.curQuesIndex}`);
    }
  }
  render() {
    const { fetchGetExamDetailSuccess, baseIndexArr, fontSize } = this.props.quesStore;

    if (!fetchGetExamDetailSuccess) return null;
    let Data = fetchGetExamDetailSuccess;
    let { QuestionType, ResultId, PaperInfo } = Data;
    return (
      <div className="ques-store-exam-page-pane">
        {
          QuestionType.length > 0 && QuestionType.map((item, key) => {
            let { Question, TypeInfo } = item;
            return (
              <div className="ques-item" key={TypeInfo.ID}>
                <div className="info" id={`questionTypeIndex${key}`}>
                  【{TypeInfo.QuestionType_Name}】{TypeInfo.QuestionType_Mark}
                </div>
                <div className="pane">
                  {
                    baseIndexArr.length > 0 && Question.map((it, i) => {
                      let index = i + baseIndexArr[key];
                      return (
                        <div key={index} className="pane-item">
                          <QuesPane
                            key={item.ID}
                            data={it}
                            index={index}
                            fontSize={fontSize}
                            resultId={ResultId}
                            busType={0}
                            ExamModel={1}
                            examPaperId={PaperInfo.ID}
                          />
                        </div>
                      )
                    })
                  }
                </div>
              </div>
            )
          })
        }
        <BackTop />
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    quesStore: state.quesStore,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(ExamPagePane));



// WEBPACK FOOTER //
// ./src/features/ques-store/ExamPagePane.js